/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatBottomSheetService } from 'src/app/services/mat-bottom-sheet.service';
import { PassportLoginComponent } from '../login/login.component';
import { BottomSheetConfig } from 'src/app/interfaces/mat.interface';
import { IonicModule, ModalController } from '@ionic/angular';
import { PassportPopUpComponent } from '../popup/popup.component';
import { PassportAddStampComponent } from '../add-stamp/add-stamp.component';
import { PassportIconComponent } from 'src/app/shared/icons/passport.component';
import { PassportMyStampsComponent } from '../my-stamps/my-stamps.component';
import { AuthService } from 'src/app/services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { BottomSheet, PopUp } from '../interfaces/passport.interface';
import { PassportService } from '../service/passport.service';

@Component({
  selector: "app-passport-fab",
  imports: [
    CommonModule,
    TranslateModule,
    IonicModule,
    PassportIconComponent
  ],  
  standalone: true,
  templateUrl: "./fab-button.component.html",
  styleUrls: ["./fab-button.component.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None
})

export class PassportFabButtonComponent {
    private modalController: ModalController = inject(ModalController);
    private matBottomSheetService: MatBottomSheetService = inject(MatBottomSheetService);
    private cookieService: CookieService = inject(CookieService);
    private authService: AuthService= inject(AuthService);
    private passportService = inject(PassportService);

    public passportEnabled = computed(() => this.passportService.passportsEnabled());
    private popUp = computed<PopUp>(() => this.passportService.passportPopup());
    public buttomSheet = computed<BottomSheet>(() => this.passportService.passportBottomSheet());
    private modal: any;

    ngAfterViewInit(){
      this.openPopUp();
    }

    openPopUp(){
      const cookie =  this.cookieService.get('passport-viewed');
      if (cookie === 'true' || this.authService.isLoggedIn() || !this.popUp())
        return;

      setTimeout(() => { 
        this.showPassportPopUp() 
      }, 5000);
    }

    public handleClick(){
      if (!this.authService.isLoggedIn()){
        this.openPassportLoginBottomSheet();
        return;
      }
      // this.openMyStampsBottomSheet();
      this.openPassportAddStampBottomSheet();
    }

    private async openPassportLoginBottomSheet() {
      const bottomSheetConfig: BottomSheetConfig<PassportLoginComponent, any> = {
          component: PassportLoginComponent,
          data: this.buttomSheet(),
          panelClass: 'passport-login-bottom-sheet'
      };
      
      await this.matBottomSheetService.openMatBottomSheet(bottomSheetConfig);
    }

    private async openPassportAddStampBottomSheet() {
      const bottomSheetConfig: BottomSheetConfig<PassportAddStampComponent, any> = {
          component: PassportAddStampComponent,
          panelClass: 'passport-add-stamp-bottom-sheet'
      };
      
      await this.matBottomSheetService.openMatBottomSheet(bottomSheetConfig);
    }

    public async openMyStampsBottomSheet() {
      const bottomSheetConfig: BottomSheetConfig<PassportMyStampsComponent, any> = {
          component: PassportMyStampsComponent,
          data: {
            idRef: 1
          }
      };
      
      await this.matBottomSheetService.openMatBottomSheet(bottomSheetConfig);
    }

    async showPassportPopUp(){
      this.modal = await this.modalController.create({
          component: PassportPopUpComponent,
          cssClass: ['passport-modal', 'ion-disable-focus-trap'],
          componentProps: {
            popUp: this.popUp()
          }
      });
      await this.modal.present();
    }
  
}
